export default "__VITE_ASSET__ClxfUJEW__"